export enum Events {
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_PAYMENT_VERIFYING = 'ORDER_PAYMENT_VERIFYING',
  ORDER_PROCESSING = 'ORDER_PROCESSING',
  ORDER_COMPLETED = 'ORDER_COMPLETED',
  ORDER_FAILED = 'ORDER_FAILED',
}
